import React from 'react';
import { Router, Routes, Route, HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from './contexts/ThemeContext';
import { UserProvider } from "./contexts/UserContext"
// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Otp from "./pages/Otp"
import Dashboard from './pages/Dashboard';
import Bot from './pages/Bot';
import Profile from './pages/Profile';
import PreWatchers from './pages/PreWatchers';
import MeanTheory from './pages/MeanTheory';
import RsiAbove70 from "./pages/RsiAbove70";

import Delistings from './pages/Delistings';
import Layout from './components/Layout';
import Navbar from './components/Navbar'; // Import Navbar

// Create QueryClient
const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
        <div className="min-h-screen bg-background-default text-white">
          <HashRouter>
            <Navbar /> {/* Use Navbar component */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/otp" element={<Otp />} />
              <Route
                path="/dashboard"
                element={
                  <Layout>
                    <Dashboard />
                  </Layout>
                }
              />
              <Route path="/bot" 
              element={
                <Layout>
                  <Bot />
                </Layout>
              } 
              />
              <Route
                path="/profile"
                element={
                  <Layout>
                    <Profile />
                  </Layout>
                }
              />
             
               <Route
                path="/prewatchers"
                element={
                  <Layout>
                    <PreWatchers />
                  </Layout>
                }
              />
               <Route
                path="/meantheory"
                element={
                  <Layout>
                    <MeanTheory />
                  </Layout>
                }
              />
               <Route
                path="/rsiAbove70"
                element={
                  <Layout>
                    <RsiAbove70 />
                  </Layout>
                }
              />
              <Route path="/delistings" element={<Delistings />} />
            </Routes>
          </HashRouter>
        </div>
        </UserProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
